import debounce from 'lodash.debounce'
import ResizeObserver from 'resize-observer-polyfill'
import { IConfiguration } from '../../domain/conf'
import { Entity } from '../../domain/entity'
import { logger } from '../../utils/common/logger'
import { DeviceTypes, DOMUtils } from '../../utils/dom'

// This is an experiment. It won't live in such form.
// Will be revisited after https://postmediadigital.atlassian.net/browse/CHEET-6638 is completed.
/* istanbul ignore next */
export class SidebarTrendingWidget extends Entity {
    private static LoopsToDetectTrendingWidget = 5
    private static DetectTrendingWidgetInterval = 100
    private static OffsetFromAd2 = 60
    private static WindowResizeDebounce = 15
    private trendingWidgetClass = 'article-content__widget-group--trending-slot'
    private trendingWidgetListClass = 'list-widget-trending'
    private ad2Class = 'ad_counter_2'
    private trendingWidgetWidth: number

    constructor(conf: IConfiguration) {
        super()
        if (conf.page.abTest && conf.page.abTest.useNewStoryPageTemplate) {
            if (this.isDesktopLayout) {
                this.position()
            } else {
                const onResize = debounce(() => {
                    if (this.isDesktopLayout) {
                        this.position()
                        window.removeEventListener('resize', onResize)
                    }
                }, SidebarTrendingWidget.WindowResizeDebounce)
                window.addEventListener('resize', onResize)
            }
        }
    }

    private get isDesktopLayout() {
        return DOMUtils.deviceType() === DeviceTypes.DESKTOP
    }

    private position(count = 0) {
        const trendingWidgetSlot: HTMLDivElement | null = document.querySelector(`.${this.trendingWidgetClass}`)
        const ad2: HTMLDivElement | null = document.querySelector(`.${this.ad2Class}`)

        if (trendingWidgetSlot && ad2 && trendingWidgetSlot.querySelector(`.${this.trendingWidgetListClass}`)) {
            const trendingWidget: HTMLDivElement | null = trendingWidgetSlot.querySelector(
                `.${this.trendingWidgetListClass}`
            )
            const adjustTopPosition = () => {
                trendingWidget.style.top = `${
                    SidebarTrendingWidget.OffsetFromAd2 + ad2.getBoundingClientRect().height
                }px`
            }

            ad2.style.position = 'relative'
            const { left: trendingLeft, width } = trendingWidget.getBoundingClientRect()
            this.trendingWidgetWidth = width
            trendingWidget.style.position = 'absolute'
            trendingWidget.style.left = `${trendingLeft}px`
            adjustTopPosition()
            trendingWidget.style.width = `${width}px`
            trendingWidgetSlot.style.gridRow = '2/span 1'
            ad2.appendChild(trendingWidget)

            const onResize = debounce(() => {
                const { left: trendingSlotLeft } = trendingWidgetSlot.getBoundingClientRect()
                trendingWidget.style.left = `${trendingSlotLeft}px`
                if (this.isDesktopLayout) {
                    trendingWidget.style.position = 'absolute'
                    trendingWidget.style.width = `${this.trendingWidgetWidth}px`
                    ad2.appendChild(trendingWidget)
                } else {
                    trendingWidget.style.position = 'unset'
                    trendingWidget.style.width = 'unset'
                    trendingWidgetSlot.appendChild(trendingWidget)
                }
            }, SidebarTrendingWidget.WindowResizeDebounce)

            const resizeObserver = new ResizeObserver(() => {
                adjustTopPosition()
            })

            resizeObserver.observe(ad2)
            window.addEventListener('resize', onResize)
        } else if (count < SidebarTrendingWidget.LoopsToDetectTrendingWidget) {
            setTimeout(() => {
                this.position(count + 1)
            }, SidebarTrendingWidget.DetectTrendingWidgetInterval)
        } else {
            logger('error', 'Could not localise trending or ad element')
        }
    }
}
